import React, { useState } from "react";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";
import { useLocation, useNavigate } from "react-router-dom";

import { auth } from "../firebase-config";
import { authErrorMessage, safeRedirectPath, MIN_PASSWORD_LENGTH } from "../lib/auth";

const provider = new GoogleAuthProvider();
// Always show the account chooser so a shared device doesn't silently
// reuse whichever Google account last signed in.
provider.setCustomParameters({ prompt: "select_account" });

function SigninSection() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");

  const [registerEmail, setRegisterEmail] = useState("");
  const [registerPassword, setRegisterPassword] = useState("");

  const [authError, setAuthError] = useState(null);

  // Return to the page RequireAuth bounced the user from.
  const onSignedIn = () => navigate(safeRedirectPath(location.state?.from), { replace: true });

  const googleSignInPopup = async () => {
    setAuthError(null);
    try {
      await signInWithPopup(auth, provider);
      onSignedIn();
    } catch (error) {
      setAuthError(authErrorMessage(error));
    }
  };

  const register = async () => {
    setAuthError(null);
    if (registerPassword.length < MIN_PASSWORD_LENGTH) {
      setAuthError(authErrorMessage({ code: "auth/weak-password" }));
      return;
    }
    try {
      const { user } = await createUserWithEmailAndPassword(
        auth,
        registerEmail,
        registerPassword
      );
      // Prove ownership of the address. Non-fatal: the account exists either
      // way and the email can be re-sent later.
      try {
        await sendEmailVerification(user);
      } catch (_) { /* best-effort */ }
      onSignedIn();
    } catch (error) {
      setAuthError(authErrorMessage(error));
    }
  };

  const login = async () => {
    setAuthError(null);
    try {
      await signInWithEmailAndPassword(auth, loginEmail, loginPassword);
      onSignedIn();
    } catch (error) {
      setAuthError(authErrorMessage(error));
    }
  };

  return (
    <div class="container-fluid">
      <div class="position-absolute top-50 start-50 translate-middle">
        {/* Login */}
        <div class="float-md-center">
          <h3 class="bpv bpw text-center">Login</h3>
        </div>

        {/* Email Address input box */}
        <div class="mb-3">
          <label for="InputEmailLogin" class="form-label">
            Email address
          </label>
          <input
            type="email"
            class="form-control"
            id="InputEmailLogin"
            autoComplete="email"
            aria-describedby="emailHelp"
            onChange={(event) => {
              setLoginEmail(event.target.value);
            }}
          />
          <div id="emailHelp" class="form-text">
            We'll never share your email with anyone else.
          </div>
        </div>
        <div class="mb-3">
          <label for="InputPasswordLogin" class="form-label">
            Password
          </label>
          <input
            type="password"
            class="form-control"
            id="InputPasswordLogin"
            autoComplete="current-password"
            onChange={(event) => {
              setLoginPassword(event.target.value);
            }}
          />
        </div>

        <div class="row">
          <div class="col text-center">
            <button class="btn btn-primary  m-2" onClick={login}>
              Login
            </button>
            {/* Registering User */}

            <button
              class="btn btn-primary m-2"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRegister"
              aria-controls="offcanvasRegister"
            >
              Register
            </button>

            <div class="col align-self-center">
              <button class="btn btn-primary  m-2" onClick={googleSignInPopup}>
                Sign in with Google <i className="fa-brands fa-google" />
              </button>
            </div>
          </div>
        </div>
        {authError && (
          <div className="alert alert-danger mt-2" role="alert">
            {authError}
          </div>
        )}
      </div>

      {/* Off Canvas Registration */}
      <div
        class="offcanvas offcanvas-start"
        tabindex="-3"
        id="offcanvasRegister"
        aria-labelledby="offcanvasRegisterLabel"
      >
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="offcanvasRegisterLabel ">
            Register
          </h5>
          <button
            type="button"
            class="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div class="offcanvas-body">
          <div class="mb-3">
            <label for="InputRegisterEmail" class="form-label">
              Email address
            </label>
            <input
              type="email"
              class="form-control"
              id="InputRegisterEmail"
              autoComplete="email"
              aria-describedby="emailHelp"
              onChange={(event) => {
                setRegisterEmail(event.target.value);
              }}
            />
            <div id="emailHelp" class="form-text">
              We'll never share your email with anyone else.
            </div>
          </div>
          <div class="mb-3">
            <label for="InputPasswordRegister" class="form-label">
              Password
            </label>
            <input
              type="password"
              class="form-control"
              id="InputPasswordRegister"
              autoComplete="new-password"
              minLength={MIN_PASSWORD_LENGTH}
              aria-describedby="passwordHelp"
              onChange={(event) => {
                setRegisterPassword(event.target.value);
              }}
            />
            <div id="passwordHelp" class="form-text">
              At least {MIN_PASSWORD_LENGTH} characters. A passphrase works well.
            </div>
            <div class="col-12 text-center m-2">
              <button onClick={register} class="btn btn-primary">
                Register
              </button>
            </div>
            {authError && (
              <div className="alert alert-danger mt-2" role="alert">
                {authError}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SigninSection;
